module.exports = __webpack_public_path__ + "img/7ne.2c6e9aa1.svg";